import {SET_EXTENSIONS} from './actions';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_EXTENSIONS:
      return action.payload.data;
    default:
      return state;
  }
};
